import axios from 'axios'
import {
  ANALYTICS_EVENTS,
  track,
  trackGtmTenantApplyNowClick,
  trackGtmTenantGuestCard,
  trackGtmTenantMessage,
  trackGtmTenantWebsiteClick,
  trackGtmTenantFavoriteListing,
  trackGtmTenantOpensListingDetail,
  trackGtmTenantPhoneCallTextMessage,
  trackGtmTenantRecommendationClick,
} from './analytics'

import { LEAD_TYPES, createLead } from './leads'
import { isAuthenticated, getAuthUrl } from './auth'
import { getFormData } from './forms'
import { setLeadAttributions, getLeadAttributions } from './lead-attributions'
import { getListingRecommendations } from './recommendations'

class SearchDetail {
  constructor() {
    this.descMaxLength = 500
    this.initializeSearchDetail()
  }

  readMore() {
    document
      .querySelector('.module.info .description')
      .classList.remove('has-show-more')
  }

  resetGuestCardModal() {
    if (!isAuthenticated()) {
      document.querySelector('.guest-card-form').classList.add('hide')

      document.querySelector('.anonymous-lead').classList.remove('hide')
    }
  }

  getRecommendations() {
    // Get listing ID
    const listingId = +document
      .querySelector('.main-wrapper')
      .getAttribute('data-listing-id')

    // Get recommendations for listing
    getListingRecommendations(listingId).then(({ data }) => {
      // Hide recommendations section if none available
      if (!data.length) {
        $('.module.recommendations').addClass('d-none')
        return
      }

      // Populate recommendations section
      let itemsHtml = ''
      data.map((listingPreview) => {
        itemsHtml += `
        <div class="col-12 col-md-6 col-lg-3">
          <div class="listing-item" data-listing-id="${
            listingPreview.listingId
          }" data-url="${listingPreview.url}">
            <a href="${listingPreview.url}" aria-label="${
          listingPreview.uiAltText
        }">
              ${
                listingPreview.ribbonText
                  ? `<span class="tag" style="background-color: ${listingPreview.ribbonColor}">${listingPreview.ribbonText}</span>`
                  : ''
              }
              <div class="img-wrapper">
                ${
                  listingPreview.thumbnailUrls.length
                    ? `<img 
                        class="image lazyload" 
                        data-src="${listingPreview.thumbnailUrls[0]}" 
                        data-sizes="auto" alt="${listingPreview.uiAltText}" 
                        onerror="this.onerror=null; this.classList.add('image-error');" />`
                    : '<div class="image no-image"></div>'
                }
              </div>
            </a>
            <a href="${listingPreview.url}" aria-label="${
          listingPreview.uiAltText
        }">
            <div class="text">
                <h3 class="price">${listingPreview.uiPrice}</h3>
                <div class="address">${listingPreview.street}<br />${
          listingPreview.uiCityState
        }</div>
                <div class="bed-bath">
                    ${listingPreview.uiBedrooms} • ${
          listingPreview.uiBathrooms
        }<br />
                    ${listingPreview.uiPropertyType}
                </div>
            </div>
        </a>
          </div>
        </div>
        `
      })

      $('.recommendations-items').html(itemsHtml)

      // Track analytics for recommendation clicks
      $('.module.recommendations .listing-item').on('click', function (e) {
        e.preventDefault()

        const href = $(this).attr('data-url')
        const recommendedListingId = +$(this).attr('data-listing-id')

        trackGtmTenantRecommendationClick(listingId, recommendedListingId, {
          eventCallback: (containerId) => {
            // Event callback will be fired twice, once for universal analytics (GTM-*) and again
            // for GA4 (G-*). This check ensures the redirect will only occur once.
            if (containerId.startsWith('GTM-')) {
              return
            }

            window.location.href = href
          },
          eventTimeout: 1500,
        })
      })
    })
  }

  initializeSearchDetail() {
    console.log('initialize search detail')

    setLeadAttributions()

    var $this = this

    //$this.getRecommendations()

    if (!isAuthenticated()) {
      $this.resetGuestCardModal()
    }

    trackGtmTenantOpensListingDetail()

    // description add cta
    const $descContent = $('.module.info .description-content')
    var $readMoreCTA = document.querySelector('.module.info .description')

    // remove all empty paragraphs and extra spaces from description
    $descContent.find('p').forEach(function (el) {
      var $this = $(el)

      if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) $this.remove()
    })

    if ($descContent.text().length > this.descMaxLength) {
      $readMoreCTA.classList.add('has-show-more')
    }

    // description cta
    $readMoreCTA.addEventListener('click', function (event) {
      event.preventDefault()
      $this.readMore()
      return false
    })

    // scroll past
    window.addEventListener('scroll', function () {
      var element = document.getElementById('request-to-apply-bar')

      if (
        window.scrollY - element.offsetHeight >
        element.offsetHeight + element.offsetTop
      ) {
        document
          .querySelector('.module.quick-apply-bar')
          .classList.add('is-active')
      } else {
        document
          .querySelector('.module.quick-apply-bar')
          .classList.remove('is-active')
      }
    })

    // favorite
    document.querySelectorAll('.btn-favorite').forEach((cta) => {
      cta.addEventListener('click', function (e) {
        e.preventDefault()

        if (!isAuthenticated()) {
          window.location.href = getAuthUrl()
          return
        }

        const listingId = +$(this).attr('data-listing-id')
        const isFavorite = $(this).attr('data-is-favorite') === 'true'
        const favoriteUri = `${rentler.apiBaseUri}/favorites`

        if (isFavorite) {
          axios.delete(`${favoriteUri}/${listingId}`).then(() => {
            document
              .querySelectorAll('.btn-favorite')
              .forEach((x) => x.setAttribute('data-is-favorite', false))
          })
        } else {
          axios.post(`${favoriteUri}`, { listingId }).then(() => {
            document
              .querySelectorAll('.btn-favorite')
              .forEach((x) => x.setAttribute('data-is-favorite', true))
            trackGtmTenantFavoriteListing({ listingId })
          })
        }
      })
    })

    // report
    $('.module.report-listing-modal').on('submit', function (e) {
      e.preventDefault()

      // validation check
      const hasErrors = $(this).find('.input-error').length > 0
      if (hasErrors) return

      // Disable and get form data
      const data = getFormData($(this).find('form')[0])
      data.listingId = +data.listingId
      data.type = +data.type

      // api request
      $(this).trigger('disable')
      const url = $(this).attr('data-api-url')
      axios
        .post(url, data)
        .then(() => {
          $(this).trigger('close')
          $('.report').attr('data-is-reported', true)
        })
        .finally(() => $(this).trigger('enable'))
    })

    // message
    $('.module.message-modal').on('submit', function (e) {
      e.preventDefault()

      // validation check
      const hasErrors = $(this).find('.input-error').length > 0
      if (hasErrors) return

      // Disable and get form data
      const data = getFormData($(this).find('form')[0])
      const attributions = getLeadAttributions()
      data.leadAttributions = attributions

      // api request
      $(this).trigger('disable')
      const url = $(this).attr('data-api-url')
      axios
        .post(url, data, { withCredentials: true })
        .then(() => {
          $(this).find('form [name]:not([type=hidden]):not(.no-reset)').val('')
          $(this)
            .find('form [name]:not([type=hidden]):not(.no-reset)')
            .trigger('blur')
          $(this).trigger('close')

          // Track GTM event
          const { Email: email } = data
          trackGtmTenantMessage({ email })
        })
        .catch((error) => {
          const { status, data } = error.response

          // Add inline validation errors next to input
          if (status === 400) {
            data.errors.forEach(({ field, message }) => {
              const inputName = field.charAt(0).toUpperCase() + field.slice(1)
              const inputs = $(this).find(
                `form [name=${inputName}]:not([type=hidden])`
              )
              inputs.forEach((el) => {
                $(el).parent().addClass('input-error')
                $(el)
                  .parent()
                  .append(`<div class="error-message">${message}</div>`)
              })
            })
          }
        })
        .finally(() => $(this).trigger('enable'))
    })

    // guest card
    $('.module.guest-card-modal').on('submit', function (e) {
      e.preventDefault()

      // validation check
      const hasErrors = $(this).find('.input-error').length > 0
      if (hasErrors) return

      // Disable and get form data
      const data = getFormData($(this).find('form')[0])
      const attributions = getLeadAttributions()
      data.leadAttributions = attributions

      // api request
      $(this).trigger('disable')
      const url = $(this).attr('data-api-url')
      let modalOnly = false
      axios
        .post(url, data)
        .then(() => {
          $(this).trigger('close')
          $(this).find('form [name]:not([type=hidden])').val('')

          // Track GTM event
          const { Email: email } = data
          trackGtmTenantGuestCard({ email })

          // Reset modal
          $this.resetGuestCardModal()
        })
        .catch((error) => {
          const { status, data } = error.response

          // Add inline validation errors next to input
          if (status === 400) {
            data.errors.forEach(({ field, message }) => {
              // AppFolio validation error when listing is no longer available
              if (field.toUpperCase() === 'LISTINGNOTFOUND') {
                modalOnly = true
                $(this).find('form').prepend(`<div class="alert alert-danger mb-1">${message}</div>`)
                return
              }

              // Normal validation errors
              const inputName = field.charAt(0).toUpperCase() + field.slice(1)
              const inputs = $(this).find(
                `form [name=${inputName}]:not([type=hidden])`
              )
              inputs.forEach((el) => {
                $(el).parent().addClass('input-error')
                $(el)
                  .parent()
                  .append(`<div class="error-message">${message}</div>`)
              })
            })
          }
          else {
            $('.module.error-modal').trigger('open')
          }
        })
        .finally(() => {
          $(this).trigger('enable', { modalOnly })
        })
    })

    // lead
    $('.module.website-click-lead-modal, .module.apply-now-lead-modal').on(
      'submit',
      function (e) {
        e.preventDefault()

        // validation check
        const hasErrors = $(this).find('.input-error').length > 0
        if (hasErrors) return

        // Disable and get form data
        const data = getFormData($(this).find('form')[0])
        const attributions = getLeadAttributions()
        data.leadAttributions = attributions

        // api request
        $(this).trigger('disable')
        const url = $(this).attr('data-api-url')
        const redirectUrl = $(this).attr('data-redirect-url')

        const win = window
        axios
          .post(url, data, { withCredentials: true })
          .then(() => {
            win.open(redirectUrl, '_blank')

            // Track gtm event
            const { Email: email } = data
            if ($(this).hasClass('apply-now-lead-modal')) {
              trackGtmTenantApplyNowClick({ email })
            } else if ($(this).hasClass('website-click-lead-modal')) {
              trackGtmTenantWebsiteClick({ email })
            }

            $(this)
              .find('form [name]:not([type=hidden]):not(.no-reset)')
              .val('')
            $(this)
              .find('form [name]:not([type=hidden]):not(.no-reset)')
              .trigger('blur')

            $(this).trigger('close')
          })
          .catch(() => {
            $('.module.error-modal').trigger('open')
          })
          .finally(() => {
            $(this).trigger('enable')
          })
      }
    )

    const listingId = document
      .querySelector('.main-wrapper')
      .getAttribute('data-listing-id')

    // lead redirect
    $('.module.website-click-lead-signed-in-modal, .module.apply-now-lead-signed-in-modal').on(
      'submit',
      function (e) {
        e.preventDefault()

        $(this).trigger('disable')

        try {
          if ($(this).hasClass('apply-now-lead-signed-in-modal')) {
            createLead(LEAD_TYPES.ApplyClick, listingId)
          } else if ($(this).hasClass('website-click-lead-signed-in-modal')) {
            createLead(LEAD_TYPES.WebsiteClick, listingId)
          }

          const redirectUrl = $(this).attr('data-redirect-url')

          window.open(redirectUrl, '_blank')

          $(this).trigger('close')
        } catch {
          $('.module.error-modal').trigger('open')
        }

        $(this).trigger('enable')
      }
    )

    // error
    $('.module.error-modal').on(
      'submit',
      function (e) {
        e.preventDefault()

        $(this).trigger('disable')

        $(this)
          .find('form [name]:not([type=hidden]):not(.no-reset)')
          .val('')
        $(this)
          .find('form [name]:not([type=hidden]):not(.no-reset)')
          .trigger('blur')
        $(this).trigger('close')

        $(this).trigger('enable')
      }
    )

    // analytics

    $('.module.guest-card-modal .anonymous-cta').on('click', function (e) {
      document.querySelector('.guest-card-form').classList.remove('hide')

      document.querySelector('.anonymous-lead').classList.add('hide')
    })

    $('.info .call-text').on('click', function (e) {
      trackGtmTenantPhoneCallTextMessage()
    })

    $(
      '.module.guest-card-modal .cancel-cta, .module.guest-card-modal .close-cta'
    ).on('click', function (e) {
      $this.resetGuestCardModal()
    })

    $('.social-share-modal .social-share-link').on('click', function (e) {
      track(ANALYTICS_EVENTS.SOCIAL_SHARE, { ListingId: listingId })
    })

    $('.get-directions-button').on('click', function (e) {
      track(ANALYTICS_EVENTS.DIRECTIONS_VIEW, { ListingId: listingId })
    })

    $('.module.hero .gallery-cta:not(.video-cta)').forEach((el) => {
      if (el.style.backgroundImage !== '') {
        track(ANALYTICS_EVENTS.PHOTO_VIEW, { ListingId: listingId })
      }
    })
  }
}

export default SearchDetail
